/**
 * Route for `conversion-crud-view-edit-reject-permission-scope`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ConversionCrudViewEditRejectPermissionScopePage } from "../features/conversion-crud-view-edit-reject-permission-scope/ConversionCrudViewEditRejectPermissionScopePage";

export const conversionCrudViewEditRejectPermissionScopeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/conversion-crud-view-edit-reject-permission-scope",
	component: ConversionCrudViewEditRejectPermissionScopePage,
});

export default conversionCrudViewEditRejectPermissionScopeRoute;
